export default __webpack_public_path__ + "static/media/bernygroup3a.25933e9c.jpg";